const quotes = {
	programming: {
	  high: [
		"You're a coding genius! The next Bill Gates in the making!",
		"Wow! You've got some serious programming skills!",
		"Amazing job! You're definitely ready for a career in tech!",
	  ],
	  medium: [
		"Great effort! Keep coding and you'll be a pro in no time!",
		"Not bad at all! With a bit more practice, you'll be unstoppable!",
		"Good job! You're on your way to becoming a coding wizard!",
	  ],
	  low: [
		"Don't give up! Every great programmer started somewhere!",
		"Keep at it! Programming is a journey, not a destination!",
		"Practice makes perfect! Why not try the quiz again?",
	  ],
	},
	sports: {
	  high: [
		"Incredible! You're a true sports encyclopedia!",
		"Wow! You could be a sports commentator with that knowledge!",
		"Amazing job! You really know your sports inside out!",
	  ],
	  medium: [
		"Great effort! You're definitely a sports fan!",
		"Not bad at all! Keep watching those games, and you'll be an expert soon!",
		"Good job! Your sports knowledge is impressive!",
	  ],
	  low: [
		"Don't worry! Even the greatest athletes had to start somewhere!",
		"Keep your head up! Why not watch some more sports and try again?",
		"Practice makes perfect! The more sports you watch, the better you'll get!",
	  ],
	},
  };
  
  export default quotes;